import React, {Fragment} from 'react';
import ErrorDiv from "root/ReactHookForm/FormComponents/ErrorDiv";
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import FieldsetContainer from "root/Base/FieldsetContainer";
import {FormInputCheckbox, FormTextarea} from "../../../ReactHookForm/FormComponents";
import DropdownEducationStatus from "root/ReactHookForm/ui/DropdownEducationStatus";

const HookSubFormPost16EducationStatus = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    const validateEducationStatus = (val) =>
    {
        if (val === null)
        {
            return "Please Select an education status.";
        }
    }

    const isOptedOut = watch(sectionName + '.pep_opt_out_flag')

    return (
        <FieldsetContainer title='Education Status' noborder={false}>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <label className='col-form-label'>Select the Education Status</label>
                    <DropdownEducationStatus name={sectionName + '.education_status_id'} control={control} rules={{validate: validateEducationStatus}}
                                                      placeHolder='Pick a CME Reason' readOnly={readOnly}/>
                    {formErrors[sectionName]?.education_status_id?.type === 'validate' && <ErrorDiv>Please select a status</ErrorDiv>}
                </BootstrapCol>
            </BootstrapRow>

            <BootstrapRow>
                <BootstrapCol width={6}>
                    <FormInputCheckbox readOnly={readOnly} label='Care Leaver?' sectionName={sectionName} name={'care_leaver_flag'}
                                        register={register}/>
                </BootstrapCol>
                <BootstrapCol width={6}>
                    <FormInputCheckbox readOnly={readOnly} label='Young Person has Opted Out Of PEP?' sectionName={sectionName} name={'pep_opt_out_flag'}
                                        register={register}/>
                </BootstrapCol>
            </BootstrapRow>

            { isOptedOut === true && <BootstrapRow>
                <BootstrapCol width={12}>
                    <FormTextarea readOnly={readOnly} label='Reason for opting out' sectionName={sectionName} name={'pep_opt_out_reason'} register={register}
                                  required={false}
                                  maxLength={1000} formErrors={formErrors}/>
                </BootstrapCol>
            </BootstrapRow> }

        </FieldsetContainer>
    )
}


export default HookSubFormPost16EducationStatus;
